<template>
  <div>
    <div class="app-title">
      <div>
        <h1><i class="fas fa-list"></i> Report</h1>
        <p>[{{ name }}]</p>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><a href="#">Home</a></li>
      </ul>
    </div>

    <!-- <div class="row">
      <div class="col-md-12">
        <div class="input-group mb-3 col-md-4 p-0">
          <div class="input-group-prepend">
            <label class="input-group-text" for="inputGroupSelect01"
              >เจ้าหน้าที่</label
            >
          </div>
          <select class="custom-select" id="inputGroupSelect01">
            <option selected>เลือก...</option>
            <option
              :value="item.id"
              v-for="(item, index) in users"
              :key="index"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-12">
        <div class="tile">
          <div class="tile-title-w-btn">
            <h3 class="title">Title</h3>
            <p>
              <button
                @click="print"
                type="button"
                class="btn btn-outline-success"
              >
                <i class="fas fa-print"></i> Print
              </button>
            </p>
          </div>
          <div class="tile-body">
            <!-- {{ dataRepairs }} -->
            <div id="printMe">
              <div class="text-center">
                <p class="h4">
                  ตารางปฏิบัติงานนอกเวลาราชการ งานสารสนเทศทางการแพทย์
                </p>
                <p class="h5">โรงพยาบาลวานรนิวาส จังหวัดสกลนคร</p>
              </div>
              <table class="table table-bordered">
                <thead class="bg-light text-center">
                  <tr>
                    <th>ลำดับ</th>
                    <th>วันที่</th>
                    <th>ชื่อ</th>
                    <th>ภารงาน/กิจกรรมที่ปฎิบัติ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in repairs" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.created_at | formatDate }}</td>
                    <td v-if="item.user_id">{{ item.user.name }}</td>
                    <td>
                      <p class="m-0">
                        ชื่อผู้ใช้งาน :
                        <span>
                          {{ item.end_user }}
                        </span>
                      </p>
                      <p class="m-0">
                        หน่วยงาน :
                        <span v-if="item.department">
                          {{ item.department.department_name }}
                        </span>
                      </p>
                      <p class="m-0">
                        รายละเอียด :
                        <span>
                          {{ item.description }}
                        </span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="text-center mt-5">
                <p>({{ username }})</p>
                <p>{{ position }}</p>
              </div>

              <div class="text-center mt-5">
                <p>(นายสุรชาติ อุดม)</p>
                <p>เจ้าพนักงานเวชกรรมฟื้นฟูชำนาญงาน</p>
                <p>หัวหน้างานสารสนเทศทางการแพทย์</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RepairsService from "../services/repairs.service";
import UsersService from "../services/users.service";

import _ from "lodash";
import httpCommon from "../services/http-common";
export default {
  data() {
    return {
      repairs: "",
      users: "",
      name: this.$route.name,
      username: JSON.parse(localStorage.getItem("user")).user.name,
      position: JSON.parse(localStorage.getItem("user")).user.position,
    };
  },
  methods: {
    async getData() {
      const res = await httpCommon.get("ot/1");
      this.repairs = res.data;
    },
    get() {
      RepairsService.getAll()
        .then((res) => {
          this.repairs = res.data;
        })
        .catch((err) => {});
    },
    getUsers() {
      UsersService.getAll()
        .then((res) => {
          this.users = res.data;
        })
        .catch((err) => {});
    },
    data_(id = 1) {
      return _.filter(this.repairs.data, function (o) {
        return o.user_id == id;
      });
    },
    async print() {
      await this.$htmlToPaper("printMe");
    },
  },
  computed: {
    dataRepairs() {
      // _.forEach(this.repairs, function (value, key) {
      // console.log(key);
      // });
      // return _.map(this.repairs, function (o) {
      //   return o.user.name;
      // });
    },
  },
  created() {
    this.getData();
    console.log();
    console.log(this.$store.state.auth);
    // this.get();
    // this.getUsers();
  },
};
</script>

<style>
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
}
p {
  margin: 0px;
}
@media print {
  body * {
    visibility: hidden;
  }
  #section-to-print,
  #section-to-print * {
    visibility: visible;
  }
  #section-to-print {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>